import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import OrganizationMenuUpsellsEditPage from "./pages/Edit";
import OrganizationMenuUpsellsIndexPage from "./pages/Index";
import OrganizationMenuUpsellsNewPage from "./pages/New";

const OrganizationMenuUpsellsPage = (props: RouteComponentProps) => {
	return (
		<div className="content">
			<Switch>
				<Route path={`${props.match.url}/new`} exact component={OrganizationMenuUpsellsNewPage} />
				<Route path={`${props.match.url}/:upsellId`} component={OrganizationMenuUpsellsEditPage} />
				<Route path={`${props.match.url}/`} component={OrganizationMenuUpsellsIndexPage} />
			</Switch>
		</div>
	);
};
export default OrganizationMenuUpsellsPage;
